<template>
  <v-container
    fluid
    :class="{
      'p-0': isMobile
    }"
  >
    <div
      id="module-content-container"
      class="px-4 py-2"
    >
      <v-row>
        <v-col
          class="py-md-6"
          :sm="12"
          :md="8"
          order="last"
          order-md="first"
        >
          <v-skeleton-loader
            v-if="isLoadingModule"
            class="w-100"
            type="table-heading, divider, actions, image"
          />
          <v-card
            v-else
            id="card-contents"
            rounded="sm"
            :elevation="0"
            :height="cardHeight"
          >  
            <v-overlay
              v-if="$store.state.module.view_dark"
              z-index="2"
              opacity="0.9"
              color="#000000"
              style="border-radius: 0;"
            />
            <v-card-text class="p-0">
              <ModuleContentComponent
                style="z-index: 3;"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          v-if="!$store.state.module.view_dark"
          :md="4"
          :sm="12"
          order="first"
          order-md="last"
          :class="{ 'pl-0': !isMobile,'px-2': isMobile }"
          class="py-md-6"
        >
          <v-skeleton-loader
            v-if="isLoadingModule"
            type="list-item-two-line, list-item-three-line, list-item-three-line, divider, list-item-three-line, actions"
            class="w-100"
          />
          <CardModuleMenu v-else />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
  
  import { studyNowRouteName } from '@/student/constants/routes'
  import CardModuleMenu from '@/student/components/module/content/CardModuleMenu.vue';
  import ModuleContentComponent from '@/student/components/module/content/ModuleContentComponent.vue';
  import { mapActions, mapGetters, mapMutations } from 'vuex';
import { FULL_HD_HEIGHT, HD_HEIGHT } from '../../../constants/general';
  
  export default {
    name: 'ShowModulePage',
    components: {
      CardModuleMenu,
      ModuleContentComponent,
  },
    data() {
      return {
        studyNowRouteName,
      }
    },
    computed: {
      ...mapGetters(['module','selectedCycle','cycles','isLoadingModule']),
      cardHeight(){

       if(!this.$store.state.module.view_dark){
        return '100%'
       }else{
        if(this.isMobile){
          
          if(this.$vuetify.breakpoint.height >= FULL_HD_HEIGHT){
            return '119vh'
          }

          if(this.$vuetify.breakpoint.height >= HD_HEIGHT && this.$vuetify.breakpoint.height < FULL_HD_HEIGHT){
            return '100vh'
          }
          
          return '121vh'

          }else{

          if(this.$vuetify.breakpoint.height >= FULL_HD_HEIGHT){
            return '66vh'
          }

          if(this.$vuetify.breakpoint.height >= HD_HEIGHT && this.$vuetify.breakpoint.height < FULL_HD_HEIGHT){
            return '98vh'
          }
          
          return '85vh'
          }
       }
       }
    },
    mounted(){
      this.getModule({ id: this.$route.params.module_id })
      .then(() => {
        const cycle = this.cycles.find(c => c.id == this.module.cycle_config_id)
        this.SET_CYCLE(cycle)
      })
      .catch(()=> {
        this.$router.push({name : this.studyNowRouteName})
      })
    },
    methods: {
      ...mapMutations(['SET_CYCLE']),
      ...mapActions(['getModule']),
    },
    
  }
</script>
<style lang="scss">
  #module-content-container .v-overlay__content {
    padding-left: 80px;
    width: 100%;
    height: 100%;
    .v-overlay__scrim{
      border-radius: 0;
    }
  }
</style>
